import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { ILocation } from '../domain/ILocation';
import { IType } from '../domain/IType';
import { Product } from '../domain/product';
import { ProductStock } from '../domain/ProductStock';
import { IProduct } from 'app/Sales/point-of-sale/domain/IProduct';
import { OverlayPanel } from 'primeng/overlaypanel';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from 'app/shared/Domains/branch';
@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  styleUrls: ['./add-product.component.css']
})
export class AddProductComponent implements OnInit {
  @ViewChild("productName", { static: false }) productNameInput: ElementRef;
  @ViewChild("barcode", { static: false }) barcodeInput: ElementRef;
  tabIndex: number;
  loading: boolean = false;
  addProfileImage: any;
  dialogVisibility: boolean;
  uploadProfile: any;
  webcamImage: any = null;
  productId: string;
  mode: string;
  Product: Product;
  filePath: any;
  productTypes: SelectItem[];
  locations: SelectItem[];
  cities: ILocation[];
  types: IType[];
  selectedProductCategory: any;
  selectedProductType: any;
  selectedProductUnit: any;
  user: IUser;
  categories: any[];
  sourceCategories: any[];
  sourceTypes: any[];
  sourceUnits: any[];
  showAddStockBox: boolean = false;
  showRemoveStockBox: boolean = false;
  stock: ProductStock;
  productStockTotalQuantity: number;
  stocks: any[];
  enterSteps: any[];
  enterProductSteps: any[];
  enterStepsTAbTwo: any[];
  currentStep: any;
  currentStepTAbTwo: any;
  isConfirmationBox: boolean;
  productsInPanel: any[];
  sourceProducts: any[];
  first: number = 0;
  rowIndex: number = -1;
  orderProduct: IProduct[];
  paymentModes = [];
  index: number = 0;
  product: Product;
  currentProductStep: any;
  displayInventory: any;
  selectedPaymentMode: any;
  totalPayment: any;
  branch: IBranch;

  constructor(
    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private appServiceManager: AppServiceManager,
    private confirmationService: ConfirmationService,
    private router: Router,
  ) {
    route.params.subscribe((params) => {
      this.productId = params["id"];
      if (this.productId !== null && this.productId !== undefined) {
        this.user = AuthService.getLoggedInUser();
        this.getProductCategories();
        this.GetProductById(this.productId);
        this.mode = 'edit';
      } else {
        this.mode = 'add';
        this.filePath = "assets/layout/images/gymSupplimentAvatar.png";

      }
      this.breadcrumbService.setItems([
        { label: "Products", routerLink: ["/products-listing"] },
        { label: "Product" },
      ]);
    });
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AddProductComponent", label);
  }
  ngOnInit() {
    this.Product = new Product();
    this.product = new Product();
    this.stock = new ProductStock();
    this.categories = [];
    this.paymentModes = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
  ];
    this.addProfileImage = "Upload";
    this.dialogVisibility = false;
    this.user = AuthService.getLoggedInUser();
    this.getProductCategories();
    this.getProducts();
    this.getBranchById();
    this.stocks = [];
    this.selectedPaymentMode = "Cash-Reception";
    this.sourceTypes = [
      { label: 'Ready to Sell', value: 'Ready to Sell' },
      { label: 'Ingredients Based', value: 'Ingredients Based' },
      { label: 'Ingredients', value: 'Ingredients' }
    ];
    this.sourceUnits = [
      { label: 'Count', value: 'Count' },
      { label: 'Ltr', value: 'Ltr' },
      { label: 'ml', value: 'ml' },
      { label: 'kg', value: 'kg' },
      { label: 'g', value: 'g' },
      { label: 'scoop', value: 'scoop' },
    ];
    this.productStockTotalQuantity = undefined;
    this.currentStep = 0;
    this.currentProductStep = 0;
    this.Product.imagePath = "assets/layout/images/gymSupplimentAvatar.png";
    this.currentStepTAbTwo = 0;
    this.isConfirmationBox = false;
    this.tabIndex = 0;
    this.orderProduct = [];
    this.enterProductSteps = [
      "rowQuantity-" + this.index,
      "rowBaseQuantity-" + this.index,
      "rowBasePrice-" + this.index,
      "rowUnit-" + this.index,
    ];

    if (this.mode == 'edit') {
      this.enterSteps = [
        "productName",
        "catagoryDd",
        "description",
        "totalQuantity",
        "wholeSalePrice",
        "purchasePrice",
        "normalPrice",
        "updateButton",
      ];
    } else if (this.mode == 'add') {
      this.enterSteps = [
        "productName",
        "catagoryDd",
        "description",
        "totalQuantity",
        "wholeSalePrice",
        "purchasePrice",
        "normalPrice",
        "saveButton"
      ];
    }

    if (this.mode == 'edit') {
      this.enterStepsTAbTwo = [
        "barcode",
        "reorderPoint",
        "reorderQuantity",
        "remarks",
        "updateButton",
      ];
    } else if (this.mode == 'add') {
      this.enterStepsTAbTwo = [
        "barcode",
        "reorderPoint",
        "reorderQuantity",
        "remarks",
        "saveButton"
      ];
    }

  }

  ngAfterViewInit() {
    this.productNameInput.nativeElement.focus();

  }

  getProductCategories() {
    this.loading = true;
    this.appServiceManager.get(`products/category/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.categories = res;
        this.categoriesDropDown(this.categories);
        // this.checkIfProductCategoryExistInDropdown(this.categories)

      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  categoriesDropDown(categories) {
    this.sourceCategories = [{ name: 'Select Product Category', code: null }];
    categories.forEach((element) => {
      this.sourceCategories.push({ name: element.name, code: element._id });
    });
  }

  GetProductById(productId) {
    this.loading = true;
    this.appServiceManager.get("products/" + productId).subscribe(
      data => {
        this.Product = data;
        this.stocks = this.Product.stocks;
        this.selectedProductCategory = this.Product.category;
        this.selectedProductType = this.Product.type;
        this.selectedProductUnit = this.Product.unit;
        this.productStockTotalQuantity = this.Product.totalQuantity;
        if (this.selectedProductUnit == "ml")
          this.displayInventory = "Product in Liters: " + this.Product.totalQuantity / 1000 + 'Ltr';
        else if (this.selectedProductUnit == "g")
          this.displayInventory = "Product in Kilograms: " + this.Product.totalQuantity / 1000 + 'kg';
        this.filePath = this.Product.imagePath;
        this.orderProduct = this.Product.ingredients;
        // this.selectedProductCategory = this.Product.category ;
        this.checkIfProductCategoryExistInDropdown(this.Product)
        // this.sourceCategories
        this.loading = false;
      },
      error => {
        this.loading = false;
        alert(error);
      }
    );
  }

  getBranchById() {
    this.loading = true;
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(this.branch){
      if (Array.isArray(this.branch.payments)) {
      this.branch.payments.forEach(payment => {
        const existingBank = this.paymentModes.find(option => option.value === `${payment.type}-${payment.name}`);
        if (!existingBank) {
            this.paymentModes.push({
                label: `${payment.type} - ${payment.name}`,
                value: `${payment.type}-${payment.name}`
            });
         }
       });
     }
    }
    if(!this.branch){
    this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch()).subscribe((res) => {
        if (res) {
            res.payments.forEach(payment => {
                const existingBank = this.paymentModes.find(option => option.value === `${payment.type}-${payment.name}`);
                if (!existingBank) {
                    this.paymentModes.push({
                        label: `${payment.type} - ${payment.name}`,
                        value: `${payment.type}-${payment.name}`
                    });
                }
            });
        } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        }
        this.loading = false;
    },
        (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
      }
}

  checkIfProductCategoryExistInDropdown(product) {
    let data = this.sourceCategories.find(x => x.code == product.category);
    if (data) {
      this.selectedProductCategory = { name: data.name, code: data.code };
    }
  }


  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
      setTimeout(() => {
        this.productNameInput.nativeElement.focus();
      }, 300);
    }
    if (index == 1) {
      this.tabIndex = 1;
      setTimeout(() => {
        this.barcodeInput.nativeElement.focus();
      }, 300);
    }
  }

  captureImageDialogShow(type) {
    this.addProfileImage = type;
    this.dialogVisibility = true;
  }

  removeProfileImage() {
    this.uploadProfile = "";
    this.Product.imagePath = "";
    this.Product.imagePath = "assets/layout/images/gymSupplimentAvatar.png";
  }

  hideAddProfileImage() {
    this.dialogVisibility = false;
  }

  handleImagefromNewProfile(webcamImage) {
    if (webcamImage) {
      this.uploadProfile = webcamImage;
      this.Product.imagePath = webcamImage;
      this.webcamImage = null;
      this.hideAddProfileImage();
    }
  }
  convertIntoBase(ingredient, ingredientUnit) {
    if (ingredientUnit == 'Ltr' || ingredientUnit == 'kg') {
      ingredient = Math.round(ingredient * 1000);
    }
    return ingredient;
  }
  calculateTotalPayment(stock, price, unit) {
    let totalPayment = 0;
       if (unit === 'Ltr') {
        totalPayment = stock * price;
    } else if (unit === 'ml') {
        totalPayment = (stock / 1000) * price;
    } else if (unit === 'kg') {
        totalPayment = stock * price;
    } else if (unit === 'g') {
        totalPayment = (stock / 1000) * price;
    } else if(unit === 'Count') {
         totalPayment = stock * price;
    }

    return totalPayment;
  }

  save() {
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to save Product ?",
      accept: () => {
        this.isConfirmationBox = false;
        var date = new Date();
        this.Product.createdOn = date;
        this.Product.company = this.user.company;
        this.Product.branch = this.user.branch;
        if (this.selectedProductType == "Ready to Sell") {
          this.Product.unit = "Count";
        }
        else {
          this.Product.unit = this.selectedProductUnit;
        }
        if (this.Product.unit == 'Ltr' || this.Product.unit == 'ml') {
          this.Product.totalQuantity = this.convertIntoBase(this.Product.totalQuantity, this.Product.unit);
          this.Product.unit = "ml";
        }
        else if (this.Product.unit == 'kg' || this.Product.unit == 'g') {
          this.Product.totalQuantity = this.convertIntoBase(this.Product.totalQuantity, this.Product.unit);
          this.Product.unit = "g";
        }
        if (this.selectedProductCategory != undefined) {
          this.Product.category = this.selectedProductCategory;
        }
        this.stock.stockQuantityAdded = this.Product.totalQuantity;
        this.stock.salePrice = this.Product.normalPrice;
        this.stock.purchasePrice = this.Product.cost;
        this.stock.wholesalePrice = this.Product.wholeSalePrice;
        this.Product.stocks = []
        this.Product.type = this.selectedProductType;
        this.Product.stocks.push(this.stock);
        this.Product.ingredients = this.orderProduct;
        this.stock.paymentMode = '';
        this.stock.totalPayment = 0;
        this.appServiceManager.post("products", this.Product).subscribe((res: any) => {
          if (res.status == true) {
            this.Product = res.product;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Product Successfully Registered' });
            this.router.navigateByUrl('product/' + this.Product._id)
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: res.error });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });

      },
      reject: () => {
        this.isConfirmationBox = false;
      }
    });
  }

  update() {
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to Update Product ?",
      accept: () => {
        this.isConfirmationBox = false;
        var date = new Date();
        this.Product.createdOn = date;
        this.Product.company = this.user.company;
        this.Product.branch = this.user.branch;
        this.Product.type = this.selectedProductType;
        this.Product.unit = this.selectedProductUnit;
        this.Product.ingredients = this.orderProduct;
        this.Product.category = this.selectedProductCategory;
        this.appServiceManager.put("products/" + this.Product._id, this.Product).subscribe((res: any) => {
          if (res) {
            this.Product = res.product;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Product Successfully Updated' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        this.isConfirmationBox = false;

      }
    });
  }

  onPaymentModeChange(value: string) {
    this.selectedPaymentMode = value;
}


  openAddStockBox() {
    this.showAddStockBox = true;
    this.stock = new ProductStock();
    this.stock.salePrice = this.Product.normalPrice;
    this.stock.purchasePrice = this.Product.cost;
    this.totalPayment = this.stock.purchasePrice;
    this.stock.wholesalePrice = this.Product.wholeSalePrice;
    this.productStockTotalQuantity = this.Product.totalQuantity;
  }
  openRemoveStockBox() {
    this.showRemoveStockBox = true;
    this.stock = new ProductStock();
    this.stock.salePrice = this.Product.normalPrice;
    this.stock.purchasePrice = this.Product.cost;
    this.stock.wholesalePrice = this.Product.wholeSalePrice;
    this.productStockTotalQuantity = this.Product.totalQuantity;
  }

  closeAddStockBox() {
    this.showAddStockBox = false;
  }
  closeRemoveStockBox() {
    this.showRemoveStockBox = false;
  }

  countTotalStockQuantity(enterdStock) {
    this.totalPayment = this.calculateTotalPayment(enterdStock,this.stock.purchasePrice,this.Product.unit);
    if (this.Product.unit == "Ltr" || this.Product.unit == "ml" || this.Product.unit == 'kg' || this.Product.unit == 'g') {
      enterdStock = this.convertIntoBase(enterdStock, this.Product.unit);
    }
    this.productStockTotalQuantity = this.Product.totalQuantity + enterdStock;
  }
  validateStockQuantity() {
    if (this.stock.stockQuantityRemoved > this.Product.totalQuantity) {
      this.stock.stockQuantityRemoved = this.Product.totalQuantity; // Restrict input
    }
  }
  removeTotalStockQuantity(enterdStock) {
    if (this.Product.unit == "Ltr" || this.Product.unit == "ml" || this.Product.unit == 'kg' || this.Product.unit == 'g') {
      enterdStock = this.convertIntoBase(enterdStock, this.Product.unit);
    }
    this.productStockTotalQuantity = this.Product.totalQuantity - enterdStock;
    this.totalPayment = this.totalPayment - this.totalPayment*enterdStock;
  }

  saveStock() {
    this.confirmationService.confirm({
      message: "Are you sure you want to add stock ?",
      accept: () => {
        this.stock.stockQuantityAdded = this.convertIntoBase(this.stock.stockQuantityAdded, this.Product.unit);
        if (this.Product.unit == "Ltr") {
          this.Product.unit = 'ml';
        }
        else if (this.Product.unit == "kg") {
          this.Product.unit = 'g';
        }
        this.stock.paymentMode = this.selectedPaymentMode;
        this.stock.totalPayment = this.totalPayment;
        this.Product.stocks.push(this.stock);
        this.Product.totalQuantity = this.productStockTotalQuantity;
        this.Product.cost = this.stock.purchasePrice;
        this.Product.wholeSalePrice = this.stock.wholesalePrice;
        this.Product.normalPrice = this.stock.salePrice;
        this.appServiceManager.put("products/" + this.Product._id, this.Product).subscribe((res: any) => {
          if (res) {
            this.GetProductById(this.productId);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Stock Added' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.showAddStockBox = false;
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }
  removeStock() {
    this.confirmationService.confirm({
      message: "Are you sure you want to remove stock ?",
      accept: () => {
        this.stock.stockQuantityRemoved = this.convertIntoBase(this.stock.stockQuantityRemoved, this.Product.unit);
        if (this.Product.unit == "Ltr") {
          this.Product.unit = 'ml';
        }
        else if (this.Product.unit == "kg") {
          this.Product.unit = 'g';
        }
        this.Product.stocks.push(this.stock);
        this.Product.totalQuantity = this.productStockTotalQuantity;
        this.Product.cost = this.stock.purchasePrice;
        this.Product.wholeSalePrice = this.stock.wholesalePrice;
        this.Product.normalPrice = this.stock.salePrice;
        this.appServiceManager.put("products/" + this.Product._id, this.Product).subscribe((res: any) => {
          if (res) {
            this.GetProductById(this.productId);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Stock Removed' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.showRemoveStockBox = false;
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }

  hotkeys($event) {
    if ($event.keyCode == 39 || $event.keyCode == 37) {
      var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
      var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
      var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
      if (confirmationBoxButtonExistLength > 0) {
        if (document.activeElement.tagName === "BODY") {
          confirmationBoxButtonExist[0].focus();
        }
        else {
          if (document.activeElement === confirmationBoxButtonExist[0]) {
            confirmationBoxButtonExist[1].focus();
          }
          else if (document.activeElement === confirmationBoxButtonExist[1]) {
            confirmationBoxButtonExist[0].focus();
          }
          else {
            confirmationBoxButtonExist[0].focus();
          }
        }
      }
    }
    else if ($event.keyCode == 13 && !this.isConfirmationBox && this.tabIndex === 0) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      if (ele.disabled && nextId == "saveButton") {
        document.getElementById("productName").focus();
        this.currentStep = 0;

      } else if (ele.disabled && nextId == "updateButton") {
        document.getElementById("productName").focus();
        this.currentStep = 0;

      } else if (nextId == "catagoryDd") {
        let ele = document.getElementById("catagoryDd").children[0] as HTMLElement;
        ele.click();
        this.currentStep = 1;
      } else {
        ele.focus();
        this.currentStep = nextStep;
      }
    } else if ($event.keyCode == 13 && !this.isConfirmationBox && this.tabIndex === 1) {
      var nextStep = this.enterStepsTAbTwo.length - 1 > this.currentStepTAbTwo ? this.currentStepTAbTwo + 1 : 0;
      var nextId = this.enterStepsTAbTwo[nextStep];
      let ele: any = document.getElementById(nextId)
      if (ele.disabled && nextId == "saveButton") {
        document.getElementById("barcode").focus();
        this.currentStepTAbTwo = 0;

      } else if (ele.disabled && nextId == "updateButton") {
        document.getElementById("barcode").focus();
        this.currentStepTAbTwo = 0;

      } else {
        ele.focus();
        this.currentStepTAbTwo = nextStep;
      }
    }
    else if ($event.keyCode == 113) {
      this.router.navigateByUrl("/product");

    }

  }

  hotClick($event) {
    if (this.tabIndex === 0) {
      let currentClickLocation = $event.target.id;
      let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.currentStep = indexOfClickField;
      } else {
        this.currentStep = this.currentStep;
      }
    } else if (this.tabIndex === 1) {
      let currentClickLocation = $event.target.id;
      let indexOfClickField = this.enterStepsTAbTwo.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.currentStepTAbTwo = indexOfClickField;
      } else {
        this.currentStepTAbTwo = this.currentStepTAbTwo;
      }
    }

  }

  getProducts() {
    this.loading = true;
    this.appServiceManager.get(`products/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.productsInPanel = res;
        this.productsInPanel = this.productsInPanel.filter(product => product.type == "Ingredients");
        this.sourceProducts = this.productsInPanel;

      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }


  searchPanelProducts(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "") {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (!value) {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (value != "") {

          if (type === "name") {
            matchedName = Object.assign([], this.sourceProducts).filter(
              cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
          }

          const distinct = (value, index, self) => {
            return self.indexOf(value) === index;
          }
          const source = matchedName;
          this.productsInPanel = source.filter(distinct);

          if (this.productsInPanel.length === 0) {
            this.productsInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          } else {
            this.first = 0;
            this.rowIndex = -1;
            if (this.productsInPanel.length === 1) {
              this.first = 0;
              this.rowIndex = -1;
            }
            this.productsInPanel = [...this.productsInPanel];
          }
        }
      } else {
        this.productsInPanel = Object.assign([], this.sourceProducts);
        this.productsInPanel = [...this.productsInPanel];
      }
    }

  }

  onPageChange(event) {
    this.first = event.first;
  }



  onProductRowSelect(event, productsPanel: OverlayPanel) {
    let check = this.orderProduct.filter(x => x.code === event.data.code);
    if (check.length > 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Product Already Added' });
    } else {
      let products = [...this.orderProduct];
      let productToBeSale = new IProduct();
      productToBeSale.name = event.data.name;
      productToBeSale.code = event.data.code;
      productToBeSale.unit = event.data.unit;
      productToBeSale.quantity = 1;
      productToBeSale.totalQuantity = event.data.totalQuantity;
      productToBeSale.cost = event.data.cost;
      productToBeSale.wholeSalePrice = event.data.wholeSalePrice;
      productToBeSale.normalPrice = event.data.normalPrice;
      productToBeSale.subTotal = productToBeSale.quantity * productToBeSale.cost;
      products.push(productToBeSale);
      this.orderProduct = products;
      productsPanel.hide();
      this.index = this.orderProduct.length - 1;
      this.enterProductSteps = [
        "rowQuantity-" + this.index,
        "rowBaseQuantity-" + this.index,
        "rowBasePrice-" + this.index,
        "rowUnit-" + this.index,
      ];
      setTimeout(() => {
        document.getElementById(this.enterProductSteps[0]).focus()
        this.currentProductStep = 0;

      }, 500);
    }
  }
  removeSelectedProduct(product) {
    let products = [...this.orderProduct];
    let index = this.orderProduct.indexOf(product);
    if (index > -1) {
      products.splice(index, 1);
      this.orderProduct = products;
      this.index = this.orderProduct.length - 1;
      this.enterProductSteps = [
        "rowQuantity-" + this.index,
        "rowBaseQuantity-" + this.index,
        "rowBasePrice-" + this.index,
        "rowUnit-" + this.index,
      ];

      setTimeout(() => {
        if (this.orderProduct.length > 0) {
          document.getElementById(this.enterProductSteps[0]).focus()
          this.currentProductStep = 0;
        }
      }, 300);
    }
  }

  quantityChangeEvent(product, type) {
    let num = 0;
    if (type === "quantity") {
      num = product.cost * product.quantity;
      product.subTotal = Math.round(num);
      let index = this.orderProduct.indexOf(product);
      this.orderProduct[index] = product;

    }
  }

}
